/* LFJ HUB — behaviour. Hub CP10 shell: safe-run wrapper + config. Later CPs append modules below.
   Rule carried from the theme: every module runs inside safeRun so one failure never kills the page. */
(function () {
  'use strict';
  var CFG = window.LFJ_HUB || {};
  function safeRun(label, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[LFJ-HUB:' + label + ']', e); } }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.LFJ_HUB_API = { safeRun: safeRun, $: $, $$: $$, cfg: CFG, reduced: REDUCED };

  /* ══ CP20 — DATA LAYER + TILES  (v2) ═══════════════════════════════════════════════════════
     Fetch real JSON → normalize → de-duplicate → combine TAKES into stacks → render EVERYTHING once (no lazy batches, so
     nothing pops in while you scroll). One data file for the portfolio: portfolio.json (written by the Discord bot).
     portfolio.json is never changed by this file: takes/duplicates are worked out here, in the browser. */
  var CATS = ['videos', 'pictures', 'stills', 'instagram', 'designs'];
  var CAT_LABEL = { videos: 'VIDEOS', pictures: 'PICTURES', stills: 'STILLS', instagram: 'INSTAGRAM', designs: 'DESIGNS' };
  var CAT_ALIAS = { collabs: 'instagram' };                      /* old name (#collabs links, bot category "collabs") */
  var S = { items: {}, units: {}, roster: [], cosigns: [], hold: false };
  CATS.forEach(function (c) { S.items[c] = []; S.units[c] = []; });
  var QS = location.search, TAKES_OFF = /[?&]takes=off\b/.test(QS), TAKES_DEBUG = /[?&]takes=debug\b/.test(QS);
  var MAX_STACK = 8;

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function getJSON(url) { return fetch(url).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); }); }
  function ytId(u) {
    var m = String(u || '').match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([\w-]{11})/);
    return m ? m[1] : '';
  }
  function sized(u, w) { /* Shopify CDN resizes on the fly — keeps thumbs small (size budget) */
    if (!u || !/cdn\.shopify\.com/i.test(u) || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function thumbFor(it) {
    if (it.thumbnail) return sized(it.thumbnail, 480);
    if (it.kind === 'yt') return 'https://i.ytimg.com/vi/' + ytId(it.url) + '/hqdefault.jpg';
    if (it.kind === 'img') return sized(it.url, 480);
    return '';
  }
  /* Site order (same rule as the bot): PINNED first → uploaded / YouTube / Instagram → card number (`order`) → newest date. */
  var GROUP_RANK = { upload: 0, youtube: 1, instagram: 2 };
  function byShowOrder(a, b) {
    return ((b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)) || (GROUP_RANK[a.source] - GROUP_RANK[b.source]) || (a.order - b.order) || String(b.date).localeCompare(String(a.date));
  }
  function monthOf(p) { return /^\d{4}-(0[1-9]|1[0-2])$/.test(p.date || '') ? p.date : (/^\d{4}$/.test(String(p.year || '')) ? p.year + '-01' : ''); }

  function buildPortfolio(doc) {
    var by = {}; CATS.forEach(function (c) { by[c] = []; });
    ((doc && doc.items) || []).forEach(function (p, i) {
      if (!p || !p.url || (p.hidden && p.source !== 'instagram')) return;   /* Instagram links always show in the Instagram tab */
      var isIg = p.source === 'instagram';
      var kind = p.source === 'youtube' ? 'yt' : isIg ? 'ig' : (p.kind === 'image' ? 'img' : 'mp4');
      var cat = CAT_ALIAS[p.category] || p.category;
      var collab = !!(p.collab_artist || p.collab_ig);
      if (isIg) cat = 'instagram';                                     /* every Instagram link lives in the Instagram tab */
      else if (p.category === 'collabs') { cat = kind === 'img' ? 'pictures' : 'videos'; collab = true; }   /* a collab is now a TAG on videos / pictures */
      if (!by[cat]) return;
      by[cat].push({ id: p.id || ('p' + i), title: p.title || 'LFJ Portfolio', showTitle: !!p.show_title, pinned: !!p.pinned,
        year: p.year || '', date: monthOf(p), role: p.role || '', artist: p.collab_artist || '', ig: p.collab_ig || '', collab: collab, url: p.url,
        kind: kind, source: p.source, thumbnail: p.thumbnail || '', order: typeof p.order === 'number' ? p.order : 0, created: p.created_at || '', cat: cat,
        group: p.take_group ? String(p.take_group) : '' });
    });
    CATS.forEach(function (c) { by[c].sort(byShowOrder); });
    return by;
  }


  var ICONS = {
    instagram: ['.##########.','#..........#','#.......#..#','#...####...#','#..#....#..#','#..#....#..#','#..#....#..#','#..#....#..#','#...####...#','#..........#','#..........#','.##########.'],
    youtube: ['............','.##########.','############','####.#######','####..######','####...#####','####...#####','####..######','####.#######','############','.##########.','............'],
    tiktok: ['.......###..','.......###.#','.......###.#','.......####.','.......###..','.##....###..','####...###..','####...###..','####...###..','.##.....#...','............','............'],
    x: ['##........##','.##......##.','..##....##..','...##..##...','....####....','.....##.....','....####....','...##..##...','..##....##..','.##......##.','##........##','............'],
    discord: ['...######...','.##########.','############','############','##..####..##','##..####..##','############','.##########.','.##.####.##.','..#......#..','............','............'],
    spotify: ['...######...','.##########.','############','##........##','############','###......###','############','####....####','############','.##########.','...######...','............'],
    soundcloud: ['............','.......###..','...#..#####.','.#.#.#######','.#.#########','.###########','.###########','............','............','............','............','............'],
    pinterest: ['...######...','..########..','.###....###.','.###....###.','.###....###.','..########..','...#####....','...###......','...###......','...##.......','..##........','............'],
    tumblr: ['....##......','....##......','..######....','....##......','....##......','....##......','....##..##..','....######..','.....####...','............','............','............'],
    facebook: ['.....####...','....######..','....##......','....##......','..########..','..########..','....##......','....##......','....##......','....##......','............','............'],
    link: ['....####....','...#....#...','..#.####.#..','..#.#..#.#..','..#.####.#..','...#....#...','....####....','............','............','............','............','............']
  };
  var PLAT = {   /* brand colours: [button background, text/icon colour] and the profile URL pattern */
    instagram: ['#e1306c', '#fff', 'https://www.instagram.com/{h}/'], youtube: ['#ff0000', '#fff', 'https://www.youtube.com/@{h}'], tiktok: ['#161823', '#25f4ee', 'https://www.tiktok.com/@{h}'],
    x: ['#ffffff', '#000', 'https://x.com/{h}'], discord: ['#5865f2', '#fff', ''], spotify: ['#1db954', '#000', ''], soundcloud: ['#ff5500', '#fff', 'https://soundcloud.com/{h}'],
    pinterest: ['#e60023', '#fff', 'https://www.pinterest.com/{h}/'], tumblr: ['#35465c', '#fff', 'https://{h}.tumblr.com'], facebook: ['#1877f2', '#fff', 'https://www.facebook.com/{h}'], link: ['#444', '#fff', '']
  };
  function handleFromUrl(u) {
    var m = /(?:instagram\.com|tiktok\.com|x\.com|twitter\.com|youtube\.com|soundcloud\.com|pinterest\.[a-z.]+|facebook\.com)\/(@?[A-Za-z0-9._-]+)/i.exec(u || '');
    if (m && !/^(p|reel|watch|channel|c|user|playlist)$/i.test(m[1])) return '@' + m[1].replace(/^@/, '');
    var t = /([A-Za-z0-9_-]+)\.tumblr\.com/i.exec(u || ''); return t ? '@' + t[1] : '';
  }
  function socialBtn(platform, handle, url, label) {
    var p = PLAT[platform] ? platform : 'link', c = PLAT[p], h = String(handle || '').trim(), href = url || (h && c[2] ? c[2].replace('{h}', h.replace(/^@/, '')) : '');
    if (!href) return '';
    var shown = h ? (h.charAt(0) === '@' ? h : '@' + h) : (handleFromUrl(href) || '');
    return '<li><a class="px hub-soc" style="--bc:' + c[0] + ';--fg:' + c[1] + '" href="' + esc(href) + '" target="_blank" rel="noopener" aria-label="' + esc((label || platform) + (shown ? ' ' + shown : '')) + '">' + icon(p, 22) + (shown ? '<span>' + esc(shown) + '</span>' : (label ? '<span>' + esc(label) + '</span>' : '')) + '</a></li>';
  }

  /* ── Picture signatures: a tiny 8x8 "fingerprint" of each thumbnail (+ its real shape, so tiles reserve the right height and
        nothing jumps while images load). Cached in localStorage so repeat visits cost nothing. ── */
  var SIG = {}, SIG_KEY = 'lfj-hub-sig2', sigDirty = false;
  try { SIG = JSON.parse(localStorage.getItem(SIG_KEY) || '{}') || {}; } catch (e) { SIG = {}; }
  function sigKey(it) { return String(it.thumbnail || it.url || '').split('?')[0]; }
  function sigOf(it) { var s = SIG[sigKey(it)]; return s ? { h: s[0] || null, r: s[1] || 0, f: !!s[2] } : null; }
  function loadSig(url) {
    return new Promise(function (res) {
      var im = new Image(), done = false; im.crossOrigin = 'anonymous';
      function fin(v) { if (!done) { done = true; res(v); } }
      im.onload = function () {
        var r = im.naturalWidth && im.naturalHeight ? im.naturalWidth / im.naturalHeight : 0, h = null, flat = false;
        try {
          var c = document.createElement('canvas'); c.width = 9; c.height = 8; var g = c.getContext('2d'); g.drawImage(im, 0, 0, 9, 8);
          var d = g.getImageData(0, 0, 9, 8).data, L = [], sum = 0, mx = 0, mn = 255;
          for (var i = 0; i < 72; i++) { var l = .2126 * d[i * 4] + .7152 * d[i * 4 + 1] + .0722 * d[i * 4 + 2]; L.push(l); sum += l; if (l > mx) mx = l; if (l < mn) mn = l; }
          flat = (sum / 72 < 14 && mx < 48) || (mx - mn < 10);          /* black / blank frames carry no information → never matched */
          h = ''; for (var y = 0; y < 8; y++) for (var x = 0; x < 8; x++) h += L[y * 9 + x] > L[y * 9 + x + 1] ? '1' : '0';
        } catch (e) { h = null; }
        fin([h, Math.round(r * 1000) / 1000, flat ? 1 : 0]);
      };
      im.onerror = function () { fin(null); };
      setTimeout(function () { fin(null); }, 4500);
      im.src = url;
    });
  }
  function computeSigs(list, budgetMs) {
    var todo = list.filter(function (it) { return (it.kind === 'img' || it.kind === 'mp4') && !SIG[sigKey(it)] && (it.thumbnail || it.kind === 'img'); });
    if (!todo.length) return Promise.resolve();
    var q = todo.slice(), run = 0;
    var pool = new Promise(function (resolve) {
      function next() {
        if (!q.length) { if (!run) resolve(); return; }
        var it = q.shift(); run++;
        loadSig(sized(it.thumbnail || it.url, 48)).then(function (v) { if (v) { SIG[sigKey(it)] = v; sigDirty = true; } run--; next(); });
      }
      for (var k = 0; k < 8; k++) next();
    });
    return Promise.race([pool, new Promise(function (r) { setTimeout(r, budgetMs); })]).then(function () {
      if (sigDirty) { try { localStorage.setItem(SIG_KEY, JSON.stringify(SIG)); } catch (e) {} sigDirty = false; }
    });
  }
  function ham(a, b) { var d = 0; for (var i = 0; i < 64; i++) if (a.charAt(i) !== b.charAt(i)) d++; return d; }
  function distOf(a, b) { var x = sigOf(a), y = sigOf(b); return (x && y && x.h && y.h && !x.f && !y.f) ? ham(x.h, y.h) : null; }

  /* ── Duplicates + takes ──────────────────────────────────────────────────────────────────
     DUPLICATE = the same file shown twice: same URL, same YouTube id, same file name (Shopify's "_uuid" copy suffix ignored) on the
                 same month, or a thumbnail that is practically pixel-identical. The later one is dropped, always.
     TAKE      = a different file from the same shoot: uploaded in the same batch AND made the same month AND looks alike (or has
                 consecutive camera numbers like IMG_6304 / IMG_6305, or the title says "take 2"). Same day / same month alone is NOT enough.
     Overrides in portfolio.json: "take_group": "any-text" on cards that belong together.  ?takes=off turns this off, ?takes=debug shows why. */
  function stemOf(u) {
    var f = ''; try { f = decodeURIComponent(String(u).split('?')[0].split('/').pop()); } catch (e) { f = String(u).split('?')[0].split('/').pop(); }
    return f.toLowerCase().replace(/\.[a-z0-9]{2,5}$/, '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '').replace(/[ _-]?\(\d+\)$/, '');
  }
  function numOf(stem) { var m = /^([a-z_\-]*?)(\d{3,})$/.exec(stem); return m ? { p: m[1], n: parseInt(m[2], 10) } : null; }
  var GENERIC_TITLE = /^(portfolio\s*#?\d*|lfj|untitled|video|photo|image|clip|img|dsc|dvd\s*\d*)$/i;
  var TAKE_WORD = /\b(take|tk|alt|angle|version|ver|cut|raw|attempt|rehearsal)\s*[#]?\d*\s*$|\(\d+\)\s*$|\bv\d+\s*$/i;
  function titleBase(t) { return String(t || '').toLowerCase().replace(TAKE_WORD, '').replace(/[\s#:_\-]+$/g, '').trim(); }
  function titleTake(a, b) {
    var ta = String(a.title || ''), tb = String(b.title || '');
    if (GENERIC_TITLE.test(ta.trim()) || GENERIC_TITLE.test(tb.trim())) return false;
    var ba = titleBase(ta), bb = titleBase(tb);
    return !!ba && ba === bb && (TAKE_WORD.test(ta.toLowerCase()) || TAKE_WORD.test(tb.toLowerCase()));
  }
  function minutesApart(a, b) { var x = Date.parse(a.created), y = Date.parse(b.created); return (isNaN(x) || isNaN(y)) ? null : Math.abs(x - y) / 60000; }

  function whyDuplicate(a, b) {
    if (a.url.split('?')[0] === b.url.split('?')[0]) return 'same file';
    if (a.kind === 'yt' && b.kind === 'yt' && ytId(a.url) && ytId(a.url) === ytId(b.url)) return 'same YouTube video';
    if (a.kind === 'ig' && b.kind === 'ig' && a.url.split('?')[0].replace(/\/$/, '') === b.url.split('?')[0].replace(/\/$/, '')) return 'same Instagram post';
    if (a.kind !== b.kind || (a.kind !== 'img' && a.kind !== 'mp4')) return '';
    var d = distOf(a, b);
    if (d !== null && d <= 2) return 'identical picture';
    var sa = stemOf(a.url), sb = stemOf(b.url);
    if (sa.length >= 5 && sa === sb && (d !== null ? d <= 20 : (a.date && a.date === b.date))) return 'same file name';
    return '';
  }
  function whyTake(a, b) {
    if ((a.kind !== 'img' && a.kind !== 'mp4') || a.kind !== b.kind) return '';
    if (a.group && a.group === b.group) return 'take_group';
    if (titleTake(a, b)) return 'title says take';
    if (!a.date || a.date !== b.date) return '';
    var gap = minutesApart(a, b), batch = gap !== null && gap <= 25;
    var d = distOf(a, b), na = numOf(stemOf(a.url)), nb = numOf(stemOf(b.url));
    var adj = !!(na && nb && na.p === nb.p && Math.abs(na.n - nb.n) <= 3);
    if (adj && (d === null || d <= 28)) return 'consecutive shots';
    if ((batch || gap === null) && d !== null && d <= 12) return 'same session, looks alike';
    return '';
  }

  function organize(list) {
    /* 1) always drop duplicates (list is already in show order, so the first one wins) */
    var keep = [], dropped = [];
    list.forEach(function (it) {
      for (var i = 0; i < keep.length; i++) { var w = whyDuplicate(keep[i], it); if (w) { dropped.push({ it: it, of: keep[i], why: w }); return; } }
      keep.push(it);
    });
    /* 2) combine takes (union-find, capped so one stack can never swallow a whole page) */
    var parent = keep.map(function (_, i) { return i; }), size = keep.map(function () { return 1; }), reason = {};
    function root(i) { while (parent[i] !== i) { parent[i] = parent[parent[i]]; i = parent[i]; } return i; }
    if (!TAKES_OFF) {
      for (var i = 0; i < keep.length; i++) for (var j = i + 1; j < keep.length; j++) {
        var w = whyTake(keep[i], keep[j]); if (!w) continue;
        var ri = root(i), rj = root(j); if (ri === rj || size[ri] + size[rj] > MAX_STACK) continue;
        parent[rj] = ri; size[ri] += size[rj]; reason[ri] = reason[ri] || w;
      }
    }
    var groups = {}, order = [];
    keep.forEach(function (it, i) { var r = root(i); if (!groups[r]) { groups[r] = []; order.push(r); } groups[r].push(it); });
    var units = order.map(function (r, n) {
      var items = groups[r];
      return { id: 'u' + n + '-' + items[0].id, items: items, stack: items.length > 1, why: reason[r] || '', pinned: items.some(function (x) { return x.pinned; }) };
    });
    return { flat: keep, units: units, dropped: dropped };
  }

  /* deterministic pseudo-random from a card id: same card = same tilt/colors on every visit */
  function hashOf(str) { var h = 2166136261; str = String(str); for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) { var a = seed >>> 0; return function () { a = (a + 0x6D2B79F5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }

  /* AUTO THUMBNAIL: a small pixel-art "screen" painted from the card id (palette + stars + scanlines), scaled up crisp.
     Used when a card has no thumbnail, the thumbnail fails to load, or it is a black frame. Better than blank. */
  var autoCache = {};
  function autoThumb(seed) {
    if (autoCache[seed]) return autoCache[seed];
    var R = rng(hashOf(seed)), W = 32, H = 18, c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d'); if (!g) return '';
    var hue = Math.floor(R() * 360), hue2 = (hue + 40 + Math.floor(R() * 120)) % 360;
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var t = y / (H - 1), n = (R() - .5) * 10, mix = Math.max(0, Math.min(1, t + (R() - .5) * .35));
      g.fillStyle = 'hsl(' + Math.round(hue + (hue2 - hue) * mix) + ',' + (55 + Math.round(R() * 20)) + '%,' + Math.max(8, Math.round(14 + t * 34 + n)) + '%)';
      g.fillRect(x, y, 1, 1);
    }
    for (var s = 0; s < 14; s++) { g.fillStyle = 'hsl(' + hue2 + ',90%,' + (70 + Math.round(R() * 25)) + '%)'; g.fillRect(Math.floor(R() * W), Math.floor(R() * (H - 5)), 1, 1); }
    for (var k = 0; k < 5; k++) { var ww = 3 + Math.floor(R() * 5), hh = 2 + Math.floor(R() * 6), xx = Math.floor(R() * (W - ww)); g.fillStyle = 'hsl(' + hue + ',50%,' + (8 + Math.round(R() * 8)) + '%)'; g.fillRect(xx, H - hh, ww, hh); }
    g.fillStyle = 'rgba(0,0,0,.18)'; for (var l = 0; l < H; l += 2) g.fillRect(0, l, W, 1);
    return (autoCache[seed] = c.toDataURL('image/png'));
  }

  var SVG_YT = '<svg viewBox="0 0 22 16" width="22" height="16" shape-rendering="crispEdges" aria-hidden="true"><path fill="#ff2e2e" d="M2 0h18v2h2v12h-2v2H2v-2H0V2h2z"/><path fill="#fff" d="M9 4l6 4-6 4z"/></svg>';
  var SVG_IG = '<svg viewBox="0 0 32 16" width="32" height="16" shape-rendering="crispEdges" aria-hidden="true"><path fill="none" stroke="#fff" stroke-width="2" d="M1 1h13v14H1z"/><path fill="#fff" d="M5 5h5v6H5zM11 3h2v2h-2z"/><path fill="none" stroke="#fff" stroke-width="2" d="M19 6h4v4h-4zM25 6h4v4h-4z"/><path stroke="#fff" stroke-width="2" d="M23 8h2"/></svg>';
  var SHOW_NUMS = /[?&]nums\b/.test(QS);

  function dateLabel(it) { var m = /^(\d{4})-(\d{2})$/.exec(it.date || ''); return m ? m[2] + '/' + m[1] : (it.year || ''); }
  function igLink(h) { h = String(h || '').trim(); if (!h) return ''; if (/^https?:\/\//i.test(h)) return h; return 'https://www.instagram.com/' + h.replace(/^@/, '').replace(/\/+$/, '') + '/'; }
  function igName(h) { h = String(h || '').trim(); var m = /instagram\.com\/([^/?#]+)/i.exec(h); return '@' + (m ? m[1] : h.replace(/^@/, '')); }

  function icon(name, px) {                                  /* pixel logos: rows of # / . → crisp SVG */
    var g = ICONS[name]; if (!g) return '';
    var d = '', w = g[0].length;
    g.forEach(function (row, y) { var m, re = /#+/g; while ((m = re.exec(row))) d += 'M' + m.index + ' ' + y + 'h' + m[0].length + 'v1h-' + m[0].length + 'z'; });
    return '<svg class="hub-ico" viewBox="0 0 ' + w + ' ' + g.length + '" width="' + (px || 14) + '" height="' + (px || 14) + '" shape-rendering="crispEdges" aria-hidden="true"><path fill="currentColor" d="' + d + '"/></svg>';
  }
  function igChip(h) { return '<a class="hub-igc" href="' + esc(igLink(h)) + '" target="_blank" rel="noopener">' + icon('instagram', 11) + '<span>' + esc(igName(h)) + '</span></a>'; }
  function collabHTML(it) {
    var who = [];
    if (it.artist) who.push('<b>' + esc(it.artist) + '</b>');
    if (it.ig) who.push(igChip(it.ig));
    if (it.role) who.push('<span>' + esc(it.role) + '</span>');
    return who.length ? 'WITH ' + who.join(' · ') : 'COLLAB';
  }
  /* small tag next to the pin: "COLLAB" → tap → who it is with. Lives OUTSIDE the open-button so tapping it never opens the video. */
  function collabTag(it) {
    if (!it.collab) return '';
    return '<button type="button" class="hub-tag" aria-expanded="false" aria-label="Collab — tap to see who with">COLLAB</button><span class="hub-tagpop" hidden>' + collabHTML(it) + '</span>';
  }

  function arOf(it) { var s = sigOf(it); return s && s.r ? Math.max(.45, Math.min(2.4, s.r)) : 0; }
  function tileStyle(it, extra) {
    var h = hashOf(it.id), r = rng(h);
    var rot = ((r() - .5) * 5).toFixed(2), dx = Math.round((r() - .5) * 20), dy = Math.round((r() - .5) * 14), hue = Math.floor(r() * 360);
    return '--n:' + (it.n || 0) + ';--rot:' + rot + 'deg;--dx:' + dx + 'px;--dy:' + dy + 'px;--hue:' + hue + (extra || '');
  }
  function srcsetFor(u) {                                   /* Shopify CDN: small files for small cards, bigger only where needed */
    if (!u || !/cdn\.shopify\.com/i.test(u)) return '';
    var base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''), j = base.indexOf('?') > -1 ? '&' : '?';
    return [240, 360, 520, 760].map(function (w) { return esc(base + j + 'width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  function thumbImg(it, eager) {
    var th = thumbFor(it), ar = it.kind === 'img' ? arOf(it) : 0, ss = srcsetFor(it.thumbnail || (it.kind === 'img' ? it.url : ''));
    return '<img src="' + esc(th || autoThumb(it.id)) + '"' + (ss ? ' srcset="' + ss + '" sizes="(max-width:699px) 44vw, (max-width:1299px) 26vw, 22vw"' : '') + ' alt=""' + (eager ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async"' +
      (ar ? ' style="aspect-ratio:' + ar + '"' : '') + (th ? '' : ' data-auto="1" class="is-auto"') + '>';
  }
  function tile(it, stackId, k) {
    var isVid = it.kind !== 'img', cls = it.kind === 'yt' ? 'yt' : it.kind === 'ig' ? 'ig' : 'file';
    var chip = it.kind === 'yt' ? '<span class="hub-chip hub-chip--yt" aria-hidden="true">' + SVG_YT + '</span>'
      : it.kind === 'ig' ? '<a class="hub-chip hub-chip--ig" href="' + esc(it.url) + '" target="_blank" rel="noopener" aria-label="Open on Instagram">' + SVG_IG + '</a>' : '';
    return '<article class="hub-tile is-' + cls + (it.pinned ? ' is-pinned' : '') + (it.collab ? ' has-tag' : '') + '" style="' + tileStyle(it) + '">' +
      '<button type="button" class="hub-open" data-id="' + esc(it.id) + '" data-cat="' + esc(it.cat) + '"' + (stackId ? ' data-stack="' + esc(stackId) + '"' : '') + ' aria-label="' + esc((isVid ? 'Play ' : 'View ') + it.title + (it.pinned ? ' (pinned)' : '')) + '">' +
      '<span class="hub-th px' + (isVid ? ' is-video' : '') + '">' + thumbImg(it, k < 6) + (isVid ? '<span class="hub-play" aria-hidden="true"></span>' : '') +
      (it.pinned ? '<span class="hub-pin" aria-hidden="true"></span>' : '') + (SHOW_NUMS ? '<span class="hub-num" aria-hidden="true">' + String((it.n || 0) + 1).padStart(2, '0') + '</span>' : '') + '</span>' +
      (it.showTitle ? '<span class="hub-cap"><span class="hub-cap-t">' + esc(it.title) + '</span></span>' : '') +
      '</button>' + chip + collabTag(it) + '</article>';
  }
  /* a stack of takes: looks like 2–3 cards piled up, with a ×N badge; tapping opens all of them */
  function stackTile(u, k) {
    var it = u.items[0], isVid = it.kind !== 'img', n = u.items.length;
    return '<article class="hub-tile is-file is-stack' + (u.pinned ? ' is-pinned' : '') + (u.items.some(function (x) { return x.collab; }) ? ' has-tag' : '') + '" style="' + tileStyle(it) + '"' + (TAKES_DEBUG ? ' title="' + esc(u.why) + '"' : '') + '>' +
      '<button type="button" class="hub-open" data-stack-open="' + esc(u.id) + '" data-cat="' + esc(it.cat) + '" aria-label="' + esc('Open ' + n + ' takes: ' + it.title) + '">' +
      '<span class="hub-layers" aria-hidden="true"><i></i>' + (n > 2 ? '<i></i>' : '') + '</span>' +
      '<span class="hub-th px' + (isVid ? ' is-video' : '') + '">' + thumbImg(it, k < 6) + (isVid ? '<span class="hub-play" aria-hidden="true"></span>' : '') +
      (u.pinned ? '<span class="hub-pin" aria-hidden="true"></span>' : '') + '</span>' +
      (it.showTitle ? '<span class="hub-cap"><span class="hub-cap-t">' + esc(it.title) + '</span></span>' : '') +
      '</button>' + (it.collab ? collabTag(it) : '') + '</article>';
  }

  var YEAR_MARKERS = true;
  function monotonic(ys) {                                   /* only draw year markers when the page really runs through time (≥85% in one direction) */
    var a = ys.filter(Boolean), up = 0, dn = 0; if (a.length < 4) return false;
    for (var i = 1; i < a.length; i++) { if (a[i] > a[i - 1]) up++; else if (a[i] < a[i - 1]) dn++; }
    return Math.min(up, dn) <= Math.max(1, (up + dn) * .15);
  }
  function emptySlot(cat) {
    return '<div class="hub-empty px"><p class="hub-empty-h" data-type="SAVE SLOT EMPTY">SAVE SLOT EMPTY</p><p class="hub-empty-p" data-type="Nothing in ' + CAT_LABEL[cat] + ' yet.">Nothing in ' + CAT_LABEL[cat] + ' yet.</p></div>';
  }
  /* everything is rendered ONCE, up front — no lazy batches, so cards never appear / vanish while you scroll */
  function renderAll(cat) {
    var grid = $('[data-grid="' + cat + '"]'); if (!grid) return;
    var units = S.units[cat];
    if (!units.length) { grid.innerHTML = emptySlot(cat); if (window.LFJ_HUB_API.observeTyping) window.LFJ_HUB_API.observeTyping(grid); return; }
    var yrOf = function (u) { var m = /^(\d{4})/.exec((u.items[0].date || u.items[0].year || '')); return m ? m[1] : ''; };
    var segOk = {}, segs = {};                                 /* markers are judged per source group (uploads / YouTube): each one runs through time on its own */
    units.forEach(function (u) { var g = u.items[0].source; (segs[g] = segs[g] || []).push(yrOf(u)); });
    Object.keys(segs).forEach(function (g) { segOk[g] = monotonic(segs[g]); });
    var last = {}, html = '';
    units.forEach(function (u, k) {
      var y = yrOf(u), g = u.items[0].source;
      if (YEAR_MARKERS && cat !== 'instagram' && segOk[g] && y && y !== last[g] && !u.pinned) { html += '<div class="hub-year" data-year="' + y + '" aria-hidden="true"><b>' + y + '</b></div>'; last[g] = y; }
      html += u.stack ? stackTile(u, k) : tile(u.items[0], null, k);
    });
    grid.innerHTML = html;
    if (window.LFJ_HUB_API.observeTyping) window.LFJ_HUB_API.observeTyping(grid);
    document.dispatchEvent(new CustomEvent('hub:rendered', { detail: { cat: cat } }));
  }
  function find(cat, id) { var l = S.items[cat] || []; for (var i = 0; i < l.length; i++) if (l[i].id === id) return l[i]; return null; }
  function findUnit(id) { for (var c = 0; c < CATS.length; c++) { var l = S.units[CATS[c]]; for (var i = 0; i < l.length; i++) if (l[i].id === id) return l[i]; } return null; }

  /* ── Stack viewer: every take as a normal portfolio page; tap one to play it (prev / next stay inside the takes) ── */
  var STK = { box: $('#hub-stack'), grid: $('#hub-stack-grid'), title: $('#hub-stack-t'), unit: null, opener: null };
  function stackOpen() { return !!(STK.box && !STK.box.hidden); }
  function openStack(u, opener) {
    if (!STK.box || !u) return;
    STK.unit = u; STK.opener = opener || document.activeElement;
    u.items.forEach(function (it, k) { it.n = k; });
    STK.grid.innerHTML = u.items.map(function (it) { return tile(it, u.id); }).join('');
    STK.title.textContent = u.items.length + ' TAKES · ' + (u.items[0].title || '').toUpperCase();
    STK.box.hidden = false; document.body.classList.add('hub-lock');
    var cl = $('.hub-mclose', STK.box); if (cl) cl.focus();
    document.dispatchEvent(new Event('hub:player-open'));
  }
  function closeStack() {
    if (!stackOpen()) return;
    STK.box.hidden = true; STK.grid.textContent = ''; STK.unit = null;
    if (!(PL && PL.box && !PL.box.hidden)) document.body.classList.remove('hub-lock');
    if (STK.opener && STK.opener.focus) { try { STK.opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var tag = t.closest('.hub-tag');                                   /* COLLAB tag → show who it is with */
    if (tag) {
      e.stopPropagation(); var pop = tag.parentNode.querySelector('.hub-tagpop'); if (!pop) return;
      var open = pop.hidden; $$('.hub-tagpop').forEach(function (p) { p.hidden = true; if (p.previousElementSibling) p.previousElementSibling.setAttribute('aria-expanded', 'false'); });
      pop.hidden = !open; tag.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    if (!t.closest('.hub-tagpop')) $$('.hub-tagpop').forEach(function (p) { if (!p.hidden) { p.hidden = true; if (p.previousElementSibling) p.previousElementSibling.setAttribute('aria-expanded', 'false'); } });
    var so = t.closest('[data-stack-open]');
    if (so) { openStack(findUnit(so.getAttribute('data-stack-open')), so); return; }
    if (t.closest('[data-sclose]')) { closeStack(); return; }
    var b = t.closest('.hub-open'); if (!b) return;
    var it = find(b.getAttribute('data-cat'), b.getAttribute('data-id')); if (!it) return;
    var sid = b.getAttribute('data-stack'), su = sid ? findUnit(sid) : null;
    if (window.LFJ_HUB_PLAYER && window.LFJ_HUB_PLAYER.open) window.LFJ_HUB_PLAYER.open(it, su ? su.items : null);
    else window.open(it.url, '_blank', 'noopener');         /* until the inline player module exists (CP50) */
  });

  document.addEventListener('error', function (e) {      /* dead thumbnail → generated pixel thumbnail, never a broken-image icon */
    var t = e.target; if (!t || t.tagName !== 'IMG' || !t.closest || !t.closest('.hub-th') || t.dataset.auto) return;
    var b = t.closest('.hub-open'); t.dataset.auto = '1'; t.classList.add('is-auto'); t.src = autoThumb(b ? (b.getAttribute('data-id') || b.getAttribute('data-stack-open')) : String(Math.random()));
  }, true);

  safeRun('data', function () {
    Promise.all([
      getJSON(CFG.portfolio).catch(function () { return { items: [] }; }),
      getJSON(CFG.roster).catch(function () { return []; }),
      CFG.cosigns ? getJSON(CFG.cosigns).catch(function () { return []; }) : Promise.resolve([]),
      CFG.config ? getJSON(CFG.config).catch(function () { return {}; }) : Promise.resolve({})
    ]).then(function (r) {
      S.cfg = (r[3] && typeof r[3] === 'object') ? r[3] : {};
      var st = S.cfg.settings || {};
      if (st.takes === false) TAKES_OFF = true;
      if (st.year_markers === false) YEAR_MARKERS = false;
      if (st.numbers === true) SHOW_NUMS = true;
      applyConfigText(S.cfg);
      S.roster = Array.isArray(r[1]) ? r[1] : [];
      S.cosigns = Array.isArray(r[2]) ? r[2] : ((r[2] && Array.isArray(r[2].items)) ? r[2].items : []);
      var by = buildPortfolio(r[0]), all = [];
      CATS.forEach(function (c) { all = all.concat(by[c]); });
      function build() {
        S.dropped = []; var changed = false;
        CATS.forEach(function (c) {
          var o = organize(by[c]), sigKeyNow = o.units.map(function (u) { return u.id; }).join('|');
          S.dropped = S.dropped.concat(o.dropped);
          if (S.units[c] && S.sigs && S.sigs[c] === sigKeyNow) return;
          (S.sigs = S.sigs || {})[c] = sigKeyNow; changed = true;
          S.items[c] = o.flat; S.units[c] = o.units;
          o.flat.forEach(function (it, k) { it.cat = c; it.n = k; });
          renderAll(c);
        });
        return changed;
      }
      /* render IMMEDIATELY from file names / titles / cached fingerprints, then refine once when new fingerprints are ready (first visit only) */
      CATS.forEach(function (c) { S.items[c] = []; S.units[c] = []; });
      build();
      (function () {
        computeSigs(TAKES_OFF ? all.filter(function (x) { return x.kind === 'img'; }) : all, 6000).then(function () { build(); });
      })();
      Promise.resolve().then(function () {
        S.dropped = S.dropped || [];
        document.body.classList.add('hub-ready');
        document.dispatchEvent(new CustomEvent('hub:ready'));
        if (TAKES_DEBUG && window.console) console.log('[LFJ-HUB] dropped duplicates:', S.dropped.map(function (d) { return d.it.id + ' ← ' + d.of.id + ' (' + d.why + ')'; }), ' stacks:', CATS.map(function (c) { return S.units[c].filter(function (u) { return u.stack; }).map(function (u) { return u.items.map(function (x) { return x.id; }).join('+') + ' (' + u.why + ')'; }); }));
      });
    });
  });
  window.LFJ_HUB_API.state = S; window.LFJ_HUB_API.cats = CATS; window.LFJ_HUB_API.labels = CAT_LABEL; window.LFJ_HUB_API.esc = esc;
  window.LFJ_HUB_API.organize = organize; window.LFJ_HUB_API.buildPortfolio = buildPortfolio; window.LFJ_HUB_API._sig = SIG; window.LFJ_HUB_API.openStack = openStack;


  /* ══ CP30 — LOCK-ON PAGER (v2: one swipe = exactly one page) ════════════════════════════════
     The old pager let the browser's scroll-snap decide, so a fast or long swipe skipped pages and felt more sensitive the harder
     you flicked. Now: the browser does NOT scroll the strip sideways. A horizontal touch swipe follows your finger 1:1, and on release it
     moves exactly ONE category (needs a deliberate swipe: ~18% of the width, or a quick short flick); otherwise it snaps back.
     Trackpad sideways-scroll = one page per gesture. Tabs, arrows, keyboard and #hash work as before. */
  var track = $('#hub-track'), rail = $('#hub-strip'), panels = $$('.hub-panel'), tabs = $$('.hub-tab'), pips = $$('.hub-pip');
  var cur = -1, hRO = null, railX = 0, farT = 0, rafX = 0, pendX = 0;
  function panelCenter(i) { var p = panels[i]; return rail.offsetLeft + p.offsetLeft - (track.clientWidth - p.offsetWidth) / 2; }
  function syncHeight() { if (cur < 0) return; track.style.height = panels[cur].offsetHeight + 'px'; }
  /* the whole strip is ONE composited layer moved with transform (no scrolling, no layout) — that is what makes the slide smooth */
  function setX(px, animate) {
    railX = px; rail.style.transition = animate ? 'transform .52s cubic-bezier(.2,.85,.25,1)' : 'none';
    rail.style.transform = 'translate3d(' + (-px) + 'px,0,0)';
  }
  function dragX(px) { pendX = px; if (!rafX) rafX = requestAnimationFrame(function () { rafX = 0; setX(pendX, false); }); }
  function setActive(i, quiet) {
    if (i === cur || i < 0 || i >= panels.length) return;
    var prev = cur; cur = i;
    var cat = CATS[i];
    document.body.setAttribute('data-cat', cat);
    clearTimeout(farT);
    var jump = prev >= 0 && Math.abs(i - prev) > 1;
    function far() { panels.forEach(function (p, k) { p.classList.toggle('is-far', Math.abs(k - cur) > 1); }); }
    if (jump) { panels.forEach(function (p) { p.classList.remove('is-far'); }); farT = setTimeout(far, 620); } else far();
    panels.forEach(function (p, k) {
      p.classList.toggle('is-active', k === i);
      if (k === i) p.removeAttribute('inert'); else p.setAttribute('inert', '');
    });
    tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
    pips.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    $$('.hub-arrow').forEach(function (a) { var n = i + (+a.getAttribute('data-dir')); a.disabled = n < 0 || n >= panels.length; });
    if (hRO) { hRO.disconnect(); hRO.observe(panels[i]); }
    syncHeight();
    if (!quiet && prev >= 0) {
      var top = track.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0) - 16;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: REDUCED ? 'auto' : 'smooth' });
      try { history.replaceState(null, '', '#' + cat); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('hub:cat', { detail: { cat: cat, index: i, count: S.items[cat].length } }));
  }
  function goTo(i, instant) {
    i = Math.max(0, Math.min(panels.length - 1, i));
    setActive(i);
    setX(panelCenter(i), !(REDUCED || instant));
  }
  function catFromHash() { var h = (location.hash || '').replace('#', ''); return CATS.indexOf(CAT_ALIAS[h] || h); }
  safeRun('pager', function () {
    if (!track || !rail || !panels.length) return;
    if ('ResizeObserver' in window) hRO = new ResizeObserver(syncHeight);

    var g = null, swallow = false;                                       /* g = the swipe in progress */
    function endSwallow() { setTimeout(function () { swallow = false; }, 60); }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      if (e.target.closest && e.target.closest('video,iframe,input,.hub-tagpop')) return;
      g = { id: e.pointerId, x: e.clientX, y: e.clientY, x0: railX, h: null, lx: e.clientX, lt: Date.now(), v: 0 };
    }, { passive: true });
    track.addEventListener('pointermove', function (e) {
      if (!g || e.pointerId !== g.id) return;
      var dx = e.clientX - g.x, dy = e.clientY - g.y;
      if (g.h === null) {
        if (Math.abs(dx) < 9 && Math.abs(dy) < 9) return;
        if (Math.abs(dx) > Math.abs(dy) * 1.25) { g.h = true; try { track.setPointerCapture(e.pointerId); } catch (x) {} track.classList.add('is-swiping'); }
        else { g = null; return; }
      }
      var now = Date.now(); if (now - g.lt > 0) { g.v = (e.clientX - g.lx) / (now - g.lt); } g.lx = e.clientX; g.lt = now;
      var atEdge = (dx > 0 && cur === 0) || (dx < 0 && cur === panels.length - 1);
      dragX(g.x0 - dx * (atEdge ? .3 : 1));
    }, { passive: true });
    function finish(e) {
      if (!g || (e && e.pointerId !== g.id)) return;
      var s = g; g = null; track.classList.remove('is-swiping');
      if (!s.h) return;
      swallow = true; endSwallow();
      var dx = (e ? e.clientX : s.lx) - s.x, quick = Date.now() - s.lt < 120 ? s.v : 0;
      var far = Math.abs(dx) > Math.min(140, track.clientWidth * .18), flick = Math.abs(quick) > .45 && Math.abs(dx) > 40;
      goTo(far || flick ? cur + (dx < 0 ? 1 : -1) : cur);                  /* never more than ONE page */
    }
    track.addEventListener('pointerup', finish); track.addEventListener('pointercancel', function (e) { if (g && g.h) finish(e); else g = null; });
    track.addEventListener('click', function (e) { if (swallow) { e.preventDefault(); e.stopPropagation(); } }, true);

    var wLock = false, wLast = 0;
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) * 1.4 || Math.abs(e.deltaX) < 4) return;
      e.preventDefault();
      var now = Date.now(); if (now - wLast > 160) wLock = false; wLast = now;
      if (wLock || Math.abs(e.deltaX) < 14) return;
      wLock = true; goTo(cur + (e.deltaX > 0 ? 1 : -1));
    }, { passive: false });

    tabs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    pips.forEach(function (p, i) { p.addEventListener('click', function () { goTo(i); }); });
    $('.hub-tablist').addEventListener('keydown', function (e) {
      var k = e.key, n = cur;
      if (k === 'ArrowRight') n = cur + 1; else if (k === 'ArrowLeft') n = cur - 1; else if (k === 'Home') n = 0; else if (k === 'End') n = panels.length - 1; else return;
      e.preventDefault(); n = Math.max(0, Math.min(panels.length - 1, n)); goTo(n); tabs[n].focus();
    });
    track.addEventListener('click', function (e) {          /* tap the peeking neighbour → go to it */
      for (var i = 0; i < panels.length; i++) {
        var r = panels[i].getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right) { if (i !== cur) { e.preventDefault(); goTo(i); } return; }
      }
    }, true);
    $$('.hub-arrow').forEach(function (a) { a.addEventListener('click', function () { goTo(cur + (+a.getAttribute('data-dir'))); }); });
    var start = catFromHash();
    setActive(start > -1 ? start : 0, true);
    setX(panelCenter(cur), false);
    window.addEventListener('resize', function () { setX(panelCenter(cur), false); syncHeight(); });
    document.addEventListener('hub:rendered', function () { syncHeight(); setX(panelCenter(cur), false); });
    window.addEventListener('hashchange', function () { var k = catFromHash(); if (k > -1 && k !== cur) goTo(k); });
  });
  window.LFJ_HUB_API.goTo = goTo;


  /* ══ CP40 — INDICATORS ═════════════════════════════════════════════════════════════════
     Side pixel meter = live page scroll progress (how much scrolling is left); top-right chip = current
     category + item count. Colour shift is CSS (body[data-cat] → --accent, animated via @property). */
  safeRun('indicators', function () {
    var meter = $('#hub-meter'), fill = $('#hub-meter-fill'), nm = $('#hub-cat-name'), ct = $('#hub-cat-count'), raf = 0, lastPct = -1;
    function pct() { var h = document.documentElement.scrollHeight - window.innerHeight; return h > 0 ? Math.max(0, Math.min(100, window.pageYOffset / h * 100)) : 0; }
    function paint() {
      raf = 0; var p = pct(); fill.style.setProperty('--p', p.toFixed(1) + '%');
      var r = Math.round(p); if (r !== lastPct) { lastPct = r; meter.setAttribute('aria-valuenow', r); }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(document.body);   /* page grows as batches load */
    var SEC_NAME = { collabed: 'COLLABED WITH', cosigns: 'COSIGNS', commission: 'COMMISSION', socials: 'SOCIALS', shop: 'SHOP', fm: 'FM' };
    window.LFJ_HUB_API.sec = 'media';
    function label(e) {
      if (window.LFJ_HUB_API.sec !== 'media') { nm.textContent = SEC_NAME[window.LFJ_HUB_API.sec] || ''; ct.textContent = ''; return; }
      var cat = (e && e.detail && e.detail.cat) || document.body.getAttribute('data-cat') || 'videos', n = S.items[cat] ? S.items[cat].length : 0;
      nm.textContent = CAT_LABEL[cat]; ct.textContent = n ? String(n) : '0';
    }
    document.addEventListener('hub:sec', function () { label(); });
    document.addEventListener('hub:cat', label); document.addEventListener('hub:ready', function () { label(); queue(); });
    label(); queue();
  });


  /* ══ CP50 — TYPING EFFECT + INLINE PLAYER ═══════════════════════════════════════════════
     typeEl(): video-game typewriter for any [data-type] element (instant under reduced motion; the full text is
     always present for screen readers). Player: pixel-framed dialog; nothing loads until a tile is tapped. */
  function typeEl(el, text, done) {
    text = text == null ? (el.getAttribute('data-type') || '') : text;
    el.classList.remove('is-done');
    el.innerHTML = '<span class="sr">' + esc(text) + '</span><span class="ty" aria-hidden="true"></span>';
    var out = el.querySelector('.ty'), i = 0, id = (el._tt = (el._tt || 0) + 1);
    function fin() { el.classList.add('is-done'); if (done) done(); }
    if (REDUCED) { out.textContent = text; return fin(); }
    (function step() {
      if (el._tt !== id) return;                              /* a newer typeEl on this node cancels this one */
      i += 1; out.textContent = text.slice(0, i);
      if (i < text.length) setTimeout(step, Math.min(24 + Math.random() * 22, 900 / Math.max(text.length, 1) + 10)); else fin();
    })();
  }
  function lineFor(cat) { var n = S.items[cat].length; return CAT_LABEL[cat] + ': ' + (n ? n + ' FILE' + (n === 1 ? '' : 'S') + ' LOADED' : 'SAVE SLOT EMPTY'); }
  var lineDone = {};
  function typeLine(cat) {
    var el = $('[data-line="' + cat + '"]'); if (!el || lineDone[cat]) return;
    lineDone[cat] = 1; typeEl(el, lineFor(cat));
  }
  safeRun('typing', function () {
    document.addEventListener('hub:cat', function (e) { typeLine(e.detail.cat); });
    document.addEventListener('hub:ready', function () { typeLine(document.body.getAttribute('data-cat')); });
    if ('IntersectionObserver' in window) {                    /* any other [data-type] text types once when it scrolls into view */
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); typeEl(e.target); } }); }, { threshold: .4 });
      window.LFJ_HUB_API.observeTyping = function (root) { $$('[data-type]', root).forEach(function (n) { io.observe(n); }); };
      window.LFJ_HUB_API.observeTyping(document);
    } else window.LFJ_HUB_API.observeTyping = function (root) { $$('[data-type]', root).forEach(function (n) { typeEl(n); }); };
  });
  window.LFJ_HUB_API.typeEl = typeEl;

  /* Player = same layout as the Gallery room viewer: top bar (prev / counter / next / CLOSE), media, bottom bar (title + date).
     Closing is easy on a phone: big CLOSE button, a full-width CLOSE bar, tap outside, swipe down, Esc. */
  var PL = { box: $('#hub-modal'), stage: $('#hub-modal-stage'), title: $('#hub-modal-t'), year: $('#hub-modal-year'), count: $('#hub-modal-count'),
    collab: $('#hub-modal-collab'), open: $('#hub-modal-open'), cat: '', idx: -1, list: [], opener: null };
  function embedFor(it) {
    if (it.kind === 'mp4') { var v = document.createElement('video'); v.controls = true; v.autoplay = true; v.playsInline = true; v.preload = 'metadata'; if (it.thumbnail) v.poster = sized(it.thumbnail, 1080); v.src = it.url; v.setAttribute('aria-label', it.title); return v; }
    if (it.kind === 'yt') { var f = document.createElement('iframe'); f.src = 'https://www.youtube-nocookie.com/embed/' + ytId(it.url) + '?autoplay=1&rel=0&playsinline=1'; f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true; f.title = it.title; return f; }
    if (it.kind === 'ig') { var g = document.createElement('iframe'); g.src = it.url.split('?')[0].replace(/\/?$/, '/') + 'embed'; g.className = 'is-tall'; g.title = it.title; g.setAttribute('loading', 'lazy'); return g; }
    var im = document.createElement('img'); im.src = sized(it.url, 1600); im.alt = it.title; return im;
  }
  function igLink(h) { h = String(h || '').trim(); if (!h) return ''; if (/^https?:\/\//i.test(h)) return h; return 'https://www.instagram.com/' + h.replace(/^@/, '').replace(/\/+$/, '') + '/'; }
  function igName(h) { h = String(h || '').trim(); var m = /instagram\.com\/([^/?#]+)/i.exec(h); return '@' + (m ? m[1] : h.replace(/^@/, '')); }
  function show(idx) {
    var list = PL.list; if (!list || !list[idx]) return;
    PL.idx = idx; var it = list[idx];
    PL.stage.textContent = '';                                   /* tear down previous media (stops playback) */
    PL.stage.appendChild(embedFor(it));
    PL.title.textContent = it.title; PL.year.textContent = dateLabel(it); PL.count.textContent = (PL.stack ? 'TAKE ' : '') + (idx + 1) + ' / ' + list.length;
    var has = it.artist || it.ig || it.role;
    PL.collab.hidden = !has; PL.collab.innerHTML = has ? collabHTML(it) : '';
    PL.open.href = it.url; PL.open.textContent = it.kind === 'ig' ? 'OPEN ON INSTAGRAM' : (it.kind === 'yt' ? 'OPEN ON YOUTUBE' : 'OPEN ORIGINAL');
    $$('.hub-mbtn[data-nav]', PL.box).forEach(function (b) { var n = idx + (+b.getAttribute('data-nav')); b.disabled = n < 0 || n >= list.length; b.style.opacity = b.disabled ? .3 : 1; });
  }
  function openPlayer(it, list) {
    if (it.kind === 'link') { window.open(it.url, '_blank', 'noopener'); return; }
    if (!PL.box.hidden) return;                                  /* a double tap must not open it twice */
    PL.stack = !!list; PL.list = list || S.items[it.cat] || [it]; var idx = PL.list.indexOf(it); if (idx < 0) return;
    document.dispatchEvent(new Event('hub:player-open'));      /* mini FM pauses when a video starts */
    PL.opener = document.activeElement; PL.box.hidden = false; document.body.classList.add('hub-lock');
    show(idx); $('.hub-mclose', PL.box).focus();
  }
  function closePlayer() {
    if (PL.box.hidden) return;
    PL.box.hidden = true; PL.stage.textContent = ''; if (!stackOpen()) document.body.classList.remove('hub-lock');
    if (PL.opener && PL.opener.focus) PL.opener.focus();
  }
  safeRun('player', function () {
    PL.box.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return closePlayer();
      var nav = e.target.closest('[data-nav]'); if (nav && !nav.disabled) show(PL.idx + (+nav.getAttribute('data-nav')));
    });
    var sx = 0, sy = 0, st = 0;                                  /* swipe: down = close, left/right = previous/next */
    PL.box.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
    PL.box.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (e.target.closest && e.target.closest('video,iframe')) return;      /* never hijack the video's own controls */
      if (dy > 90 && Math.abs(dx) < 70 && Date.now() - st < 700) closePlayer();
      else if (Math.abs(dx) > 80 && Math.abs(dy) < 60) show(PL.idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (PL.box.hidden) { if (e.key === 'Escape' && stackOpen()) closeStack(); return; }
      if (e.key === 'Escape') closePlayer();
      else if (e.key === 'ArrowLeft' && !(e.target.tagName === 'VIDEO')) show(PL.idx - 1);
      else if (e.key === 'ArrowRight' && !(e.target.tagName === 'VIDEO')) show(PL.idx + 1);
      else if (e.key === 'Tab') {                                /* keep focus inside the dialog */
        var f = $$('button:not([disabled]),a[href]', PL.box); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.LFJ_HUB_PLAYER = { open: openPlayer, close: closePlayer };
  });

  /* ══ CP60 — PROMO SECTIONS ═════════════════════════════════════════════════════════════
     Markup is server-rendered (Liquid + settings). JS only ticks the optional shop countdown. */
  safeRun('countdown', function () {
    var box = $('#hub-count'), out = $('#hub-count-t'); if (!box || !out) return;
    var end = new Date(box.getAttribute('data-date')).getTime();
    if (isNaN(end)) { box.hidden = true; return; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    (function tick() {
      var d = Math.max(0, end - Date.now()), sec = Math.floor(d / 1000);
      out.textContent = pad(Math.floor(sec / 86400)) + ':' + pad(Math.floor(sec % 86400 / 3600)) + ':' + pad(Math.floor(sec % 3600 / 60)) + ':' + pad(sec % 60);
      if (d > 0) setTimeout(tick, 1000); else box.classList.add('is-over');
    })();
  });


  /* ══ CP70 — SECTION DOTS + MINI FM ═════════════════════════════════════════════════════
     Dots under the meter jump to the promo sections and light up for the one in view (also drives the top-right
     chip). Mini FM: playlist.json is fetched ONLY on the first PLAY (size budget); tap-only start (autoplay rule). */
  safeRun('sections', function () {
    var dots = $$('[data-sec-dot]'), secs = $$('[data-sec]'), media = $('#media');
    function set(id) {
      if (window.LFJ_HUB_API.sec === id) return; window.LFJ_HUB_API.sec = id;
      dots.forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-sec-dot') === id); });
      document.dispatchEvent(new CustomEvent('hub:sec', { detail: { id: id } }));
    }
    function jump(id) {                                          /* content above the target can grow mid-scroll (batches load) → re-aim a few times */
      var el = document.getElementById(id); if (!el) return; var tries = 0; S.hold = true;   /* freeze batch loading so the page can't grow under the jump */
      (function go() {
        var top = el.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
        window.scrollTo({ top: top, behavior: (tries || REDUCED) ? 'auto' : 'smooth' });
        if (++tries < 3) setTimeout(go, 450); else setTimeout(function () { S.hold = false; }, 300);
      })();
    }
    window.LFJ_HUB_API.jump = jump;
    dots.forEach(function (d) { d.addEventListener('click', function (e) { e.preventDefault(); var id = d.getAttribute('data-sec-dot'); jump(id); try { history.replaceState(null, '', '#' + id); } catch (x) {} }); });
    document.addEventListener('hub:ready', function () { var h = (location.hash || '').replace('#', ''); if (h && $('[data-sec]#' + h)) setTimeout(function () { jump(h); }, 150); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) set(e.target.id === 'media' ? 'media' : e.target.id); });
    }, { rootMargin: '-30% 0px -65% 0px' });                   /* the thin band 30% down the screen decides — where a jumped-to section lands */
    secs.concat(media ? [media] : []).forEach(function (n) { io.observe(n); });
  });

  safeRun('fm', function () {
    var btn = $('#hub-fm-play'), nx = $('#hub-fm-next'), now = $('#hub-fm-now'), eq = $('#hub-eq'); if (!btn) return;
    var audio = null, list = null, i = 0, fails = 0;
    function nice(u, artist) {
      var f = decodeURIComponent(String(u).split('?')[0].split('/').pop()).replace(/\.(mp3|wav|m4a|ogg)$/i, '').replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
      return (artist ? artist + ' — ' : '') + f;
    }
    function ui(on) { btn.textContent = on ? 'PAUSE' : 'PLAY'; btn.setAttribute('aria-pressed', on ? 'true' : 'false'); eq.classList.toggle('is-on', on && !REDUCED); }
    function load(k) {
      i = (k + list.length) % list.length; audio.src = list[i].url; typeEl(now, nice(list[i].url, list[i].artist));
      return audio.play().then(function () { fails = 0; }).catch(function () { if (++fails < 4) load(i + 1); else { ui(false); now.textContent = 'Could not play right now.'; } });
    }
    function build(pl) {
      var out = [];
      Object.keys(pl || {}).forEach(function (a) { (Array.isArray(pl[a]) ? pl[a] : []).forEach(function (u) { if (u) out.push({ artist: a, url: u }); }); });
      for (var k = out.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)), t = out[k]; out[k] = out[j]; out[j] = t; }
      return out;
    }
    function ensure() {
      if (list) return Promise.resolve();
      now.textContent = 'Tuning in…';
      return getJSON(CFG.playlist).then(function (pl) {
        list = build(pl); if (!list.length) throw new Error('empty');
        audio = new Audio(); audio.preload = 'none';
        audio.addEventListener('ended', function () { load(i + 1); });
        audio.addEventListener('play', function () { ui(true); }); audio.addEventListener('pause', function () { ui(false); });
        nx.disabled = false;
      });
    }
    btn.addEventListener('click', function () {
      if (audio && !audio.paused) { audio.pause(); return; }
      ensure().then(function () { if (audio.src) audio.play().catch(function () {}); else load(0); }).catch(function () { now.textContent = 'FM is unavailable right now.'; });
    });
    nx.addEventListener('click', function () { if (list) load(i + 1); });
    document.addEventListener('hub:player-open', function () { if (audio && !audio.paused) audio.pause(); });
    window.LFJ_HUB_FM = { pause: function () { if (audio) audio.pause(); } };
  });


  /* ══ CP80 — BOTTOM BAR ═════════════════════════════════════════════════════════════════ */
  safeRun('bottom', function () {
    var up = $('#hub-totop'); if (!up) return;
    up.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
      var m = $('#hub-main'); if (m) setTimeout(function () { m.focus({ preventScroll: true }); }, REDUCED ? 0 : 700);   /* keyboard users land at the top, not stranded at the footer */
      try { history.replaceState(null, '', location.pathname + (CATS[0] ? '#' + document.body.getAttribute('data-cat') : '')); } catch (e) {}
    });
  });


  /* ══ BOTTOM TEXTBOX — chill version ═════════════════════════════════════════════════════
     Same Pokemon-style box as About / Commission. It never blocks taps (pointer-events:none in CSS), shows the greeting
     once per visit, a short line when YOU change category, and a keyboard-focus hint at most every 8 seconds. */
  safeRun('dialog', function () {
    var box = $('#hub-dialog'), out = $('#hub-dialog-t'), sr = $('#hub-dialog-sr'); if (!box) return;
    var typeT = 0, hideT = 0, last = 0, ready = false;
    function hide() { clearTimeout(typeT); clearTimeout(hideT); box.hidden = true; }
    function say(text, force) {
      var m = $('#hub-modal'); if (!text || (m && !m.hidden)) return;
      var now = Date.now(); if (!force && now - last < 8000) return; last = now;
      clearTimeout(typeT); clearTimeout(hideT); sr.textContent = text; box.hidden = false; box.classList.remove('is-done'); out.textContent = '';
      function done() { box.classList.add('is-done'); hideT = setTimeout(hide, 2600); }
      if (REDUCED) { out.textContent = text; return done(); }
      var i = 0; (function step() { i += 1; out.textContent = text.slice(0, i); if (i < text.length) typeT = setTimeout(step, 20); else done(); })();
    }
    document.addEventListener('hub:player-open', hide);
    document.addEventListener('hub:ready', function () {
      ready = true; var seen = false; try { seen = sessionStorage.getItem('lfj-hub-greeted') === '1'; sessionStorage.setItem('lfj-hub-greeted', '1'); } catch (e) {}
      if (!seen) setTimeout(function () { say('> ' + (CFG.greeting || 'LFJ PORTFOLIO'), true); }, 600);
    });
    document.addEventListener('hub:cat', function (e) { if (ready && e.detail.userMoved !== false) say('> ' + CAT_LABEL[e.detail.cat] + ': ' + (e.detail.count ? e.detail.count + ' FILES' : 'SAVE SLOT EMPTY'), true); });
    document.addEventListener('focusin', function (e) {          /* keyboard only — mouse/touch never trigger it */
      var b = e.target.closest ? e.target.closest('.hub-open') : null; if (!b || !ready || !b.matches(':focus-visible')) return;
      var it = find(b.getAttribute('data-cat'), b.getAttribute('data-id')); if (it) say('> ' + it.title + ' · ' + dateLabel(it));
    });
  });

  /* ══ SOUND ═══════════════════════════════════════════════════════════════════════════════
     Tiny 8-bit blips made with the Web Audio API (no audio files = 0 bytes). One sound per click, played from a single
     delegated listener. SND button (top) toggles and remembers. */
  safeRun('sound', function () {
    var btn = $('#hub-snd'), on = true, ctx = null, log = [];
    try { on = localStorage.getItem('lfj-hub-snd') !== '0'; } catch (e) {}
    function paint() { if (!btn) return; btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.setAttribute('aria-label', on ? 'Sound on — tap to mute' : 'Sound off — tap to unmute'); btn.querySelector('span').textContent = on ? 'SND ON' : 'SND OFF'; btn.classList.toggle('is-off', !on); }
    function ac() { if (!ctx) { var C = window.AudioContext || window.webkitAudioContext; if (!C) return null; try { ctx = new C(); } catch (e) { return null; } } if (ctx.state === 'suspended') ctx.resume(); return ctx; }
    function tone(c, f0, f1, dur, type, vol, at) {
      var o = c.createOscillator(), g = c.createGain(), t = c.currentTime + (at || 0);
      o.type = type; o.frequency.setValueAtTime(f0, t); o.frequency.exponentialRampToValueAtTime(Math.max(30, f1), t + dur);
      g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(.0001, t + dur); o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + dur + .02);
    }
    var BANK = {
      tap: function (c) { tone(c, 880, 1320, .07, 'square', .06); },
      tab: function (c) { tone(c, 520, 780, .06, 'square', .06); tone(c, 780, 1040, .07, 'square', .05, .06); },
      open: function (c) { tone(c, 440, 440, .06, 'square', .06); tone(c, 660, 660, .06, 'square', .06, .06); tone(c, 990, 1320, .1, 'square', .06, .12); },
      close: function (c) { tone(c, 990, 660, .07, 'square', .06); tone(c, 660, 330, .1, 'square', .06, .07); },
      on: function (c) { tone(c, 660, 1320, .12, 'triangle', .08); }
    };
    function sfx(name) { log.push(name); if (log.length > 60) log.shift(); if (!on) return; var c = ac(); if (c && BANK[name]) { try { BANK[name](c); } catch (e) {} } }
    window.LFJ_HUB_API.sfx = sfx; window.LFJ_HUB_API.sfxLog = log;
    paint();
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button,a[href],[role=tab]') : null; if (!t) return;
      if (t.id === 'hub-snd') { on = !on; try { localStorage.setItem('lfj-hub-snd', on ? '1' : '0'); } catch (x) {} paint(); if (on) sfx('on'); else log.push('off'); return; }
      sfx(t.closest('[data-close]') ? 'close' : t.classList.contains('hub-open') || t.closest('.hub-open') ? 'open' : t.classList.contains('hub-tab') || t.classList.contains('hub-arrow') ? 'tab' : 'tap');
    }, true);
  });

  /* ══ CARD LIFE: black-thumbnail swap, hover preview, in-view animation ═════════════════════
     Black frames: the thumbnail is sampled on a tiny canvas; if it is (nearly) pure black it is swapped for the
     generated pixel thumbnail. Cross-origin images that can't be read are simply left alone (never breaks a good one). */
  safeRun('cards-alive', function () {
    var blackCache = {};
    function swap(im) { var b = im.closest('.hub-open'); im.dataset.auto = '1'; im.classList.add('is-auto'); im.src = autoThumb(b ? b.getAttribute('data-id') : 'x'); }
    function judge(im, src) {
      var t = new Image(); t.crossOrigin = 'anonymous';
      t.onload = function () {
        var bad = false;
        try {
          var c = document.createElement('canvas'); c.width = c.height = 8; var g = c.getContext('2d'); g.drawImage(t, 0, 0, 8, 8);
          var d = g.getImageData(0, 0, 8, 8).data, sum = 0, mx = 0;
          for (var i = 0; i < d.length; i += 4) { var l = .2126 * d[i] + .7152 * d[i + 1] + .0722 * d[i + 2]; sum += l; if (l > mx) mx = l; }
          bad = (sum / 64) < 14 && mx < 48;
        } catch (e) { bad = false; }
        blackCache[src] = bad; if (bad) swap(im);
      };
      t.onerror = function () { blackCache[src] = false; };
      t.src = src;
    }
    document.addEventListener('load', function (e) {
      var im = e.target; if (!im || im.tagName !== 'IMG' || im.dataset.auto || !im.closest || !im.closest('.hub-th')) return;
      var src = im.currentSrc || im.src; if (!/cdn\.shopify\.com/.test(src)) return;
      if (src in blackCache) { if (blackCache[src]) swap(im); return; }
      judge(im, src);
    }, true);
    window.LFJ_HUB_API.autoThumb = autoThumb;

    var can = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches && !REDUCED && !(navigator.connection && navigator.connection.saveData);
    if (can) {
      var hv = { t: 0, tile: null, v: null };
      var stop = function () { clearTimeout(hv.t); if (hv.v && hv.v.parentNode) hv.v.parentNode.removeChild(hv.v); hv.v = null; hv.tile = null; };
      document.addEventListener('mouseover', function (e) {
        var tl = e.target.closest ? e.target.closest('.hub-tile.is-file:not(.is-stack)') : null; if (!tl || tl === hv.tile) return; stop(); hv.tile = tl;
        hv.t = setTimeout(function () {
          var b = tl.querySelector('.hub-open'), it = b && find(b.getAttribute('data-cat'), b.getAttribute('data-id')); if (!it || it.kind !== 'mp4') return;
          var v = document.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none'; v.className = 'hub-prev'; v.setAttribute('aria-hidden', 'true'); v.src = it.url;
          tl.querySelector('.hub-th').appendChild(v); hv.v = v; v.play().catch(function () {});
        }, 350);
      });
      document.addEventListener('mouseout', function (e) { var tl = e.target.closest ? e.target.closest('.hub-tile') : null; if (tl && tl === hv.tile && !tl.contains(e.relatedTarget)) stop(); });
    }
  });

  /* first 20 seconds: neighbouring categories nudge toward the middle now and then, inviting a swipe, then they stay calm */
  safeRun('swipe-hint', function () {
    if (REDUCED) return;
    document.addEventListener('hub:ready', function () { document.body.classList.add('hub-nudge'); setTimeout(function () { document.body.classList.remove('hub-nudge'); }, 20000); });
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) { $('#hub-track') && $('#hub-track').addEventListener(ev, function () { document.body.classList.remove('hub-nudge'); }, { passive: true, once: true }); });
  });

  /* ══ FOLDS — the little > on every section minimises / restores it (remembered on this device) ══ */
  safeRun('folds', function () {
    var KEY = 'lfj-hub-fold', saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { saved = {}; }
    function persist() { try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {} }
    function set(btn, folded) {
      var id = btn.getAttribute('data-fold'), tgt = document.getElementById(id); if (!tgt) return;
      tgt.hidden = folded; btn.setAttribute('aria-expanded', folded ? 'false' : 'true');
      var host = btn.closest('.hub-card,.hub-linebar'); if (host) host.classList.toggle('is-folded', folded);
      var nm = btn.getAttribute('data-name') || 'section'; btn.setAttribute('aria-label', (folded ? 'Expand ' : 'Collapse ') + nm);
      if (folded) saved[id] = 1; else delete saved[id];
      syncHeight();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.hub-fold') : null; if (!b) return;
      set(b, b.getAttribute('aria-expanded') !== 'false'); persist();
    });
    $$('.hub-fold').forEach(function (b) { if (saved[b.getAttribute('data-fold')]) set(b, true); });
  });

  /* ══ COLLABED WITH + COSIGNS — two small sections under the portfolio ═══════════════════════
     Collabed with = worked-with.json (name, handle, url, cosigned_by).  Cosigns = cosigns.json (screenshots of support):
     [{ "image": "https://…png", "artist": "Name", "handle": "@ig", "url": "", "note": "" }]  — an empty / missing file shows a quiet empty line. */
  safeRun('collabed', function () {
    function render() {
      var ul = $('#collabed-list'), box = $('#cosign-list'), cn = $('#cosign-note');
      if (ul) {
        var rows = prioritized(S.roster.filter(function (r) { return r && r.name; }));
        ul.innerHTML = rows.length ? rows.map(function (r) {
          var href = r.url || (r.handle ? igLink(r.handle) : '');
          var nm = esc(r.name);
          return '<li>' + (href ? '<a href="' + esc(href) + '" target="_blank" rel="noopener">' + nm + '</a>' : '<span>' + nm + '</span>') + (r.handle ? igChip(r.handle) : '') + (r.cosigned_by ? '<em>cosign: ' + esc(r.cosigned_by) + '</em>' : '') + '</li>';
        }).join('') : '<li class="hub-none">Nobody listed yet.</li>';
      }
      if (box) {
        var items = S.cosigns.filter(function (c) { return c && c.image; }).map(function (c, i) {
          return { id: 'cos' + i, cat: 'cosigns', kind: 'img', title: c.artist || 'Cosign', url: c.image, thumbnail: c.image, date: '', year: '', artist: c.artist || '', ig: c.handle || '', role: c.note || '', collab: true, showTitle: false };
        });
        S.cosignItems = items;
        box.innerHTML = items.length ? items.map(function (it, i) {
          return '<li><button type="button" class="hub-cos" data-cos="' + i + '" aria-label="' + esc('View cosign from ' + it.title) + '"><img src="' + esc(sized(it.url, 360)) + '" alt="" loading="lazy" decoding="async"><span>' + esc(it.title) + '</span></button></li>';
        }).join('') : '<li class="hub-none">No cosigns added yet.</li>';
        if (cn) cn.hidden = !items.length;
      }
    }
    document.addEventListener('hub:ready', render);
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.hub-cos') : null; if (!b) return;
      var it = (S.cosignItems || [])[+b.getAttribute('data-cos')];
      if (it && window.LFJ_HUB_PLAYER) window.LFJ_HUB_PLAYER.open(it, S.cosignItems);
    });
  });


  /* ══ SITE CONFIG (assets/site-config.json — edited through the bot) ═══════════════════════════
     { commission:{text,buttons:[{label,href}]}, socials:[{platform,handle,url}], shop:{text}, fm:{text},
       collabed_order:["name or @handle",…], settings:{takes,year_markers,numbers,default_tab} }
     Anything missing keeps the text that is already on the page. */
  function setText(el, t) { if (!el || t == null || t === '') return; el.setAttribute('data-type', t); el.textContent = t; }
  function btns(box, list) {
    if (!box || !Array.isArray(list) || !list.length) return;
    box.innerHTML = list.filter(function (b) { return b && b.label && b.href; }).map(function (b, i) { return '<a class="hub-btn' + (i ? ' hub-btn--alt' : '') + ' px" href="' + esc(b.href) + '">' + esc(b.label) + '</a>'; }).join('');
  }
  function decorateSocials() {                               /* names → real (pixel) logos, buttons coloured by brand, @handle beside the logo */
    $$('#hub-social a.hub-soc[data-platform]').forEach(function (a) {
      var pl = a.getAttribute('data-platform'), c = PLAT[pl] || PLAT.link, h = handleFromUrl(a.getAttribute('href')), lab = a.getAttribute('data-label') || '';
      a.style.setProperty('--bc', c[0]); a.style.setProperty('--fg', c[1]);
      a.innerHTML = icon(pl, 22) + (h ? '<span>' + esc(h) + '</span>' : (lab ? '<span>' + esc(lab) + '</span>' : ''));
      a.setAttribute('aria-label', (a.querySelector('.sr') ? '' : '') + pl + ' ' + (h || lab));
    });
  }
  function applyConfigText(cfg) {
    safeRun('config', function () {
      if (cfg.commission) { setText($('#commission-text'), cfg.commission.text); btns($('#commission-btns'), cfg.commission.buttons); }
      if (cfg.shop) setText($('#shop-text'), cfg.shop.text);
      if (cfg.fm && cfg.fm.text) { var n = $('#hub-fm-now'); if (n) n.textContent = cfg.fm.text; }
      if (Array.isArray(cfg.socials) && cfg.socials.length) {
        var ul = $('#hub-social'); if (ul) ul.innerHTML = cfg.socials.map(function (x) { return socialBtn(String(x.platform || '').toLowerCase(), x.handle, x.url, x.label); }).join('');
      } else decorateSocials();
      if (cfg.settings && cfg.settings.default_tab && !location.hash) { var k = CATS.indexOf(CAT_ALIAS[cfg.settings.default_tab] || cfg.settings.default_tab); if (k > 0 && window.LFJ_HUB_API.goTo) setTimeout(function () { window.LFJ_HUB_API.goTo(k, true); }, 0); }
    });
  }
  function prioritized(rows) {                               /* worked-with.json `priority` (bigger first) / `featured`, then bot's collabed_order, then file order */
    var order = ((S.cfg && S.cfg.collabed_order) || []).map(function (x) { return String(x).toLowerCase().replace(/^@/, ''); });
    function rank(r) { var i = order.indexOf(String(r.name || '').toLowerCase()); if (i < 0 && r.handle) i = order.indexOf(String(r.handle).toLowerCase().replace(/^@/, '')); return i < 0 ? 999 : i; }
    return rows.map(function (r, i) { return { r: r, i: i }; }).sort(function (a, b) {
      return (rank(a.r) - rank(b.r)) || ((+b.r.priority || 0) - (+a.r.priority || 0)) || ((b.r.featured ? 1 : 0) - (a.r.featured ? 1 : 0)) || (a.i - b.i);
    }).map(function (x) { return x.r; });
  }

  /* ══ YEAR TICKER — a light label that tells you which year you are scrolling through ═══════ */
  safeRun('yearticker', function () {
    var tick = $('#hub-yeartick'), raf = 0, hideT = 0, lastY = '';
    if (!tick) return;
    function paint() {
      raf = 0;
      var p = $('.hub-panel.is-active'); if (!p) return;
      var ys = $$('.hub-year', p), y = '', line = window.innerHeight * .42, box = p.getBoundingClientRect();
      if (box.top > line || box.bottom < line * .6) { tick.classList.remove('is-on'); return; }
      for (var i = 0; i < ys.length; i++) { if (ys[i].getBoundingClientRect().top <= line) y = ys[i].getAttribute('data-year'); else break; }
      if (!y && ys.length) y = ys[0].getAttribute('data-year');
      if (!y) { tick.classList.remove('is-on'); return; }
      if (y !== lastY) { tick.textContent = y; lastY = y; }
      tick.classList.add('is-on'); clearTimeout(hideT); hideT = setTimeout(function () { tick.classList.remove('is-on'); }, 1400);
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
  });

  /* @MODULES */
})();
